/* tslint:disable */
import { VComponent } from './vcomponent';

/**
 */
export class ResultCalculateFreeze {
    CheckCalculate?: number;
    VComponent?: VComponent;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/result-calculate-freeze.ts